import React, { useEffect, useState } from 'react'
import { pagesText } from '../../../constants/english'
import { getCurrencySymbol, transformFirstLetter } from '../../../helpers/helpers'
import { useDispatch, useSelector } from 'react-redux'
import { getRequest } from '../../../helpers/request'
import { appApi } from '../../../utils/endpoints/appApi'
import { clearResetBot, onGetComments } from '../../../config/redux/slice/appSlice'
import { convertDateTime } from '../../../utils/lib'

export default function CertificateComments({certificateObject}) {
  const dispatch = useDispatch()

  const {
        token,
        userData,
        email
  } = useSelector((state) => state.authData)

  const {
      certificateManagement:{
        comments,
        newComment
      }
  } = useSelector((state) => state.app)

  const removeCommentFromHeader = (e, idValue, classNameValue)=>{
      let element = document.getElementById(`${idValue}`)
      let elementAll = document.getElementsByClassNameName(`${classNameValue}`)
      for(let x = 0; x < elementAll.length; x++){
        elementAll[x].style.display = 'block'
      }
      if(e.currentTarget.classNameList.contains('collapsed')){
        element.style.display = 'none'
      }
    }

    useEffect(()=>{
      if(newComment){
        getAllComments()
          dispatch(clearResetBot())
      }       
    }, [newComment])

  useEffect(() => {
        getAllComments()

    },[])

    const getAllComments = async () =>{
      let id = certificateObject?.ID
      const res = await getRequest(
        token,
        `${appApi.getComments(id)}`,
        {},
        dispatch,
        "",
        onGetComments,
        ""
      )
    }
  return (

           <div className="card border-0 card-default chat-right-sidebar details-child">

      <div className="card-body pb-0 pl-2 pr-0">
        {comments.length > 0 ? 
        <>
        {comments.map((comment, i)=>{
        return (
          <div key={i}>
          {comment?.SENDER_ID === email ?          
          <div className="media media-chat media-chat-right">
          <div className="media-body">
            <div className="text-content border">
              <span className="message">{comment?.COMMENTS}</span>
              <span className="time">{convertDateTime(comment?.CREATED_AT, 'YYYY-MM-DD')}</span>
            </div>
          </div>
        </div> :
        <div className="media media-chat">
          <div className="media-body">
            <div className="text-content">
              <span className='font-weight-bold text-light'>
                <span>~{comment?.SENDER_NAME}</span>{' '}
                {/* <span style={{textTransform: 'capitalize', fontSize: '0.6rem'}} className={`badge ${comment?.COMMENT_MODE == 'EXTERNAL' ? 'badge-danger' : 'badge-warning'} text-white`}>{comment?.COMMENT_MODE}</span> */}
              </span>
              <span className="message">{comment?.COMMENTS}.</span>
              <span className="time">{convertDateTime(comment?.CREATED_AT, 'YYYY-MM-DD')}</span>
            </div>
          </div>
        </div>}
        </div>)})}</>
        :
      <p>No Comments</p>}
      </div>
    </div>
      
  )
}
